if (!customElements.get('multicolumn-carousel-progress')) {
  class MulticolumnCarouselProgress extends HTMLElement {
    connectedCallback() {
      this.sliderComponent = this.closest('slider-component');
      this.slider = this.sliderComponent?.querySelector('[id^="Slider-"]');
      this.fill = this.querySelector('.multicolumn-carousel__progress-fill');

      if (!this.slider || !this.fill) return;

      this.onScroll = this.update.bind(this);
      this.slider.addEventListener('scroll', this.onScroll, { passive: true });

      this.resizeObserver = new ResizeObserver(() => this.update());
      this.resizeObserver.observe(this.slider);

      this.sliderComponent?.addEventListener('slideChanged', this.onScroll);
      this.update();
    }

    disconnectedCallback() {
      this.slider?.removeEventListener('scroll', this.onScroll);
      this.sliderComponent?.removeEventListener('slideChanged', this.onScroll);
      this.resizeObserver?.disconnect();
    }

    update() {
      const slides = Array.from(this.slider.querySelectorAll('.slider__slide')).filter(
        (slide) => slide.clientWidth > 0
      );

      if (slides.length < 2) {
        this.fill.style.width = '100%';
        return;
      }

      const slideOffset = slides[1].offsetLeft - slides[0].offsetLeft;
      const maxScroll = this.slider.scrollWidth - this.slider.clientWidth;
      const scrollRatio = maxScroll > 0 ? this.slider.scrollLeft / maxScroll : 0;
      const pageCount = Math.max(slides.length - 1, 1);
      const pageRatio = scrollRatio * pageCount;
      const currentPage = Math.min(Math.round(pageRatio), pageCount);
      const fillRatio = (currentPage + 1) / slides.length;

      this.fill.style.width = `${fillRatio * 100}%`;
    }
  }

  customElements.define('multicolumn-carousel-progress', MulticolumnCarouselProgress);
}
